export const getGladstoneData = () => ({
  name: "Gladstone",
  region: "Wairarapa",
  country: "Nouvelle-Zélande",
  description: "Gladstone est une sous-région viticole de Wairarapa, réputée pour ses vins rouges et blancs de qualité. Cette zone bénéficie d'un climat tempéré et de sols argileux, favorisant l'équilibre et la complexité des vins.",
  type: "subregion",
  area: "400 ha",
  production: "0.03 million hectolitres",
  climate: "Climat tempéré avec influences maritimes, étés chauds et hivers doux",
  soil: "Sols argileux, bonne rétention d'eau, faible fertilité",
  characteristics: {
    climate: "Climat tempéré avec influences maritimes, étés chauds et hivers doux",
    soil: "Sols argileux, bonne rétention d'eau, faible fertilité",
    viticulture: "Viticulture durable, rendements contrôlés, qualité privilégiée"
  },
  wineStyles: {
    red: "Pinot Noir structuré, Syrah élégante, notes de fruits rouges et d'épices",
    white: "Chardonnay équilibré, Sauvignon Blanc frais et aromatique",
    rosé: "Rosés fruités et délicats"
  },
  history: "Gladstone s'est développée dans les années 1990 comme une zone viticole dynamique de Wairarapa. Les producteurs locaux privilégient la qualité et l'innovation, avec une attention particulière à la durabilité.",
  foodPairing: "Viandes blanches, poissons, fromages affinés, plats locaux, cuisine fusion",
  grapeVarieties: [
    { name: "Pinot Noir", percentage: "40%", description: "Vins rouges élégants, tanins fins, fruits rouges" },
    { name: "Chardonnay", percentage: "25%", description: "Vins blancs équilibrés, notes de fruits blancs" },
    { name: "Sauvignon Blanc", percentage: "20%", description: "Vins frais, aromatiques, acidité vive" },
    { name: "Syrah", percentage: "10%", description: "Vins rouges épicés, élégants" },
    { name: "Autres", percentage: "5%", description: "Pinot Gris, Riesling, expérimentaux" }
  ],
  statistics: {
    totalArea: "400 ha",
    production: "0.03 million hectolitres",
    wineries: "10+ domaines",
    exportPercentage: "35%"
  },
  viticulture: "La viticulture à Gladstone privilégie la durabilité et la qualité. Les rendements sont limités pour préserver l'intensité aromatique. L'irrigation est utilisée avec parcimonie.",
  winemaking: "La vinification se fait en cuves inox et en fûts de chêne selon le style recherché. Les blancs sont souvent élevés sur lies pour plus de texture.",
  terroir: "Gladstone est caractérisée par ses sols argileux et son climat tempéré. Les vignes bénéficient d'une bonne rétention d'eau et d'une maturation lente, favorisant la complexité des vins.",
  mapAreas: [
    { region: "Gladstone", x: 175.6, y: -41.1, color: "#6d2c7a", size: 3 }
  ]
}); 